import type { BaseRecord, ResourceProps } from "@refinedev/core";
import type { TableProps } from "antd";

export const APP_RESOURCE = [
  {
    name: "index", // /对应的资源, 不加这个直接访问 /会 no access.
    list: "/",
    meta: {
      hide: true,
    },
  },
  {
    name: "admin_dashboard",
    list: "/analytics",
    show: "/dashboard/*",
    meta: {
      icon: false,
    },
  },
  {
    name: "property_list",
    list: "/properties",
    show: "/properties/:id",
    create: "/properties/create",
    edit: "/properties/edit/:id",
    meta: {
      permissions: ["addRoom", "deleteRoom", "editRoom"],
      icon: false,
    },
  },

  // 物件详情下的资源
  { name: "property_buildings", create: "/properties/create/:id" },
  { name: "property_services" },
  {
    name: "property_deliveries",
    show: "/properties/:id/services/:serviceId/delivery-setting",
    meta: { parent: "property_services" },
  },
  {
    name: "property_service_associated_lockers",
    show: "/properties/:id/services/:serviceId/associated-locker",
    meta: { parent: "property_services" },
  },
  {
    name: "property_service_pass_providers",
    show: "/properties/:id/services/:serviceId/pass-providers",
    meta: { parent: "property_services" },
  },
  { name: "property_devices", show: "/devices-config/:id/:deviceId" }, // 这里的devices指门禁设备,
  {
    name: "property_lockers",
    create: "/properties/:id/locker-stations/create",
    edit: "/properties/:id/locker-stations/:lockerStationId/edit",
    show: "/properties/:id/locker-stations/:lockerStationId",
  },
  // 物件详情中 tab 入館デバイス 的按钮 デバイス記録,
  // 同样的路径在 unhealthy-devices 也有, 这里专门声明一个是因为aiphone角色需要访问这个页面
  {
    name: "property_deivces_events",
    list: "/devices-config/:imei/events",
    show: "/devices-config/:imei/events/:id",
    meta: {
      hide: true,
    },
  },

  {
    name: "device_list",
    list: "/devices",
    create: "/devices/create",
    edit: "/devices/edit/:id",
    show: "/devices/:id",
    meta: {
      icon: false,
    },
  },
  {
    name: "imei",
    list: "/devices-config/imei",
    show: "/devices-config/imei/:imei/events",
  },
  { name: "imei-events", list: "/devices-config/:imei/events/:id" },
  {
    name: "unlock_record",
    list: "/dashboard/unlock-record",
  },
  {
    name: "users_configure",
    meta: {
      icon: false,
    },
  },
  {
    name: "users",
    list: "/users",
    show: "/users/:id",
    meta: {
      parent: "users_configure",
    },
  },
  {
    name: "customers",
    list: "/customers",
    show: "/customers/:id",
    meta: {
      parent: "users_configure",
    },
  },
  {
    name: "pass_users",
    list: "/pass_users",
    show: "/pass_users/:id",
    meta: {
      parent: "users_configure",
    },
  },
  {
    name: "service_management",
    meta: {
      icon: false,
    },
  },
  {
    name: "service_records",
    list: "/service-records",
    show: "/service-records/:type/events/:eventId",
    meta: {
      parent: "service_management",
    },
  },
  {
    name: "eazy_update_delete",
    list: "/eazy-update-delete",
    meta: {
      parent: "service_management",
    },
  },
  {
    name: "todo_management",
    list: "/todo_management",
    meta: {
      icon: false,
      hide: true,
    },
  },
  {
    name: "todo_management",
    list: "/todo_management/completed",
    meta: {
      icon: false,
      hide: true,
    },
  },
  // 下面都是不会在菜单中出现, 测试人员会使用的一些资源
  {
    name: "quality_assurance_tool",
    meta: {
      icon: false,
      hide: true,
    },
  },
  {
    name: "quality_assurance_tool_dashboard",
    list: "/dashboard",
    meta: {
      parent: "quality_assurance_tool",
      hide: true,
    },
  },
  {
    name: "unlock_record_dashboard",
    list: "/dashboard/unlock-record?service=amazon",
    meta: {
      parent: "quality_assurance_tool",
      hide: true,
    },
  },
  {
    name: "charge-unlock-record",
    list: "/dashboard/charge-unlock-record",
    meta: {
      parent: "quality_assurance_tool",
      hide: true,
    },
  },
  {
    name: "registered-devices",
    list: "/dashboard/devices/registered",
    show: "/dashboard/devices/unlock/:id",
    meta: {
      parent: "quality_assurance_tool",
      hide: true,
    },
  },
  {
    name: "properties-no-amazon",
    list: "/dashboard/properties/no-amazon",
    meta: {
      parent: "quality_assurance_tool",
      hide: true,
    },
  },
  {
    name: "unhealthy-devices",
    list: "/dashboard/devices/unhealthy",
    show: "devices-config/:id/events",
    meta: {
      parent: "quality_assurance_tool",
      hide: true,
    },
  },
] satisfies ResourceProps[];

export const TABLE_PROPS = {
  bordered: true,
  rowKey: "id",
  scroll: { x: "max-content" },
} satisfies TableProps<BaseRecord>;

export const PROPERTY_MANAGER = "PropertyManager";
export const PROPERTY_STAFF = "PropertyStaff";
export const SYSTEM_MANAGER = "SystemManager";
export const TENANT_MANAGER = "TenantManager";
export const ENTRANCE_INSTALLER = "EntranceInstaller";
export const LOCKER_INSTALLER = "LockerInstaller";

export const TOKYO_TIMEZONE = "Asia/Tokyo";
